import * as React from "react"

const SvgComponent = (props) => (
  <svg width={23} height={23} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{"background"}</title>
    <path fill="none" d="M-1-1h582v402H-1z" />
    <title>{"Layer 1"}</title>
    <path fill="none" d="M0 0h48v48H0V0z" />
    <path
      fill="#fff"
      d="M38.71 20.07C37.35 13.19 31.28 8 24 8c-5.78 0-10.79 3.28-13.3 8.07C4.69 16.72 0 21.81 0 28c0 6.63 5.37 12 12 12h26c5.52 0 10-4.48 10-10 0-5.28-4.11-9.56-9.29-9.93zM34 26 24 36 14 26h6v-8h8v8h6z"
    />
  </svg>
)

export default SvgComponent
